import { Field } from '@progress/kendo-react-form';
import './serviceReminderBlock.css';
import { FaEnvelope, FaGhost, FaPhoneAlt, FaPlusCircle, FaTimesCircle } from 'react-icons/fa';
import { FormDatePicker } from '../../components/FormComps/FormComponents';
import dayjs from 'dayjs';

export interface ServiceStep { 
    icon: "phone" | "email" | "expired";
    daysRemaining: number;
    completed: boolean;
    expired: boolean;
    date: string | null;
    disabled?: boolean;
    identity: string;
    onChange: (key: string, value: string) => void;
    lockEdit: boolean;
}

const ServiceReminderBlock = ({icon, date, daysRemaining, completed, expired, disabled = false, onChange, identity, lockEdit}: ServiceStep) => {
    return(
        <div className={`service-block ${completed ? "service-block--completed" : null}`}>
            <div className="service-block__indicator">
                { completed ? <FaPlusCircle /> : <FaTimesCircle />}
            </div>
            <div className="service-block__row">
                <div className="service-block__label">
                    { completed ? "Completed" : expired ? "Expired" : `${daysRemaining} days` }
                </div>
                <div className="service-block__icon">
                    { icon === "phone" ? <FaPhoneAlt /> : null }
                    { icon === "email" ? <FaEnvelope /> : null }
                    { icon === "expired" ? <FaGhost /> : null }
                </div>
            </div>
            <div className="service-block__row">
                <div className="servive-block__date">
                <Field
                    disabled={lockEdit}
                    name={'clients'}
                    component={FormDatePicker}
                    defaultValue={date ? new Date(date) : null}
                    onChange={(e) => {
                        onChange(identity, dayjs(e.value).format('YYYY-MM-DD'))
                    }}
                />                    
                </div>
            </div>
        </div>
    )
}

export default ServiceReminderBlock;